
import axios from "@/utils/axios";
const testApi = {
  getShopList: (params?: object) => axios.post("/spring-festival/front/festivalTime/getSpringFestivalTimes", params||{}),//门店列表
  getCityList: (params?: object) => axios.post("/spring-festival/front/city/getSortCityList", params||{}),//门店列表
}
export default testApi



